<template>
	<div class="page" v-if="page">
		<section class="section">
			<div class="container content is-fullhd">
				<div class="title">Teams</div>

				<div class="box">
					<table class="table is-fullwidth">
						<thead>
							<tr>
								<th class="has-text-right">#</th>
								<th>Team</th>
								<th class="has-text-centered">Record</th>
								<th class="has-text-centered" v-if="page.has_divisions">Division</th>
								<th title="Points For" class="has-text-right">
									<span class="title-text">PF</span>
								</th>
								<th title="Points Against" class="has-text-right">
									<span class="title-text">PA</span>
								</th>
								<th class="has-text-right">Power</th>
								<th title="Acc." class="has-text-right">
									<span class="title-text">Lineup Accuracy</span>
								</th>
								<th class="has-text-right">Luck</th>
								<th title="Strength of Schedule" class="has-text-right">
									<span class="title-text">SOS</span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="team in page.teams">
								<td class="has-text-right">{{ team.standing_rank }}</td>
								<td><TeamLink :teamKey="team.key" :teamName="team.name" /></td>
								<td class="has-text-centered">{{ team.record }}</td>
								<td class="has-text-centered" v-if="page.has_divisions">{{ team.division_record }}</td>
								<td class="has-text-right">{{ team.points_for }}</td>
								<td class="has-text-right">{{ team.points_against }}</td>
								<td class="has-text-right">{{ team.power_rating }}</td>
								<td class="has-text-right">{{ team.lineup_accuracy }}</td>
								<td class="has-text-right">{{ team.luck }}</td>
								<td class="has-text-right">{{ team.strength_of_schedule }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		<pre>{{ page }}</pre>
	</div>
</template>

<script>
import TeamLink from "@/components/TeamLink"

export default {
	components: {
		TeamLink,
	},
	computed: {
		league() {
			return this.$store.getters.activeLeague
		},
		page() {
			return this.$store.getters.activePage
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "compare_teams")
	},
}
</script>

<style scoped>
.container {
	margin-top: 1.5rem;
}
</style>
